import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import {
  GetBoardPayloadType,
  GetColumnCardsPayloadType,
  MoveCardPayloadType,
  PinCardPayloadType,
  CreateColumnPayloadType,
  UpdateColumnPayloadType,
  DeleteColumnPayloadType,
  ReorderColumnsPayloadType,
} from "../../store/admin/crmBoard";
import { cookieToken } from "../../constants";

const getBoard = (data: GetBoardPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.crmBoard.board;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getColumnCards = (data: GetColumnCardsPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const { columnId, ...payloadData } = data;
  const endpoint = api.admin.crmBoard.columnCards.replace('{columnId}', columnId.toString());

  const payload = {
    ...payloadData,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const moveCard = (data: MoveCardPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const { cardId, ...payloadData } = data;
  const endpoint = api.admin.crmBoard.moveCard.replace('{cardId}', cardId.toString());

  const payload = {
    ...payloadData,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('PATCH', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const pinCard = (data: PinCardPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const { cardId, ...payloadData } = data;
  const endpoint = api.admin.crmBoard.pinCard.replace('{cardId}', cardId.toString());

  const payload = {
    ...payloadData,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('PATCH', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createColumn = (data: CreateColumnPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.crmBoard.createColumn;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateColumn = (data: UpdateColumnPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const { columnId, ...payloadData } = data;
  const endpoint = api.admin.crmBoard.updateColumn.replace('{columnId}', columnId.toString());

  const payload = {
    ...payloadData,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('PATCH', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteColumn = (data: DeleteColumnPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const { columnId, platformId, version, replacementColumnId } = data;
  const endpoint = api.admin.crmBoard.deleteColumn.replace('{columnId}', columnId.toString());

  const query = `?platformId=${platformId}&version=${version}`
    + (replacementColumnId ? `&replacementColumnId=${replacementColumnId}` : '')
    + `&authenticity_token=${authenticity_token}`;

  return fetch(
    `${endpoint}${query}`,
    {...RequestOptions('DELETE')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const reorderColumns = (data: ReorderColumnsPayloadType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.crmBoard.reorderColumns;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const crmBoardService = {
  getBoard,
  getColumnCards,
  moveCard,
  pinCard,
  createColumn,
  updateColumn,
  deleteColumn,
  reorderColumns,
};
